import store from "@/store";
import { initedPromise, addEventListener } from "@/lib/auth";

export function getNum(type) {
    const { ticket } = store.state;

    return `${ticket.menu[type]}`;
}

/**
 * 表单筛选默认时间设置
 * @return time
 */
export function setTime() {
    let endTime = new Date();
    let startTime = endTime.getTime() - 30 * 24 * 60 * 60 * 1000;
    startTime = new Date(startTime); // 将毫秒进行转化为接口所需格式
    return [startTime, endTime];
}

let tid;
function stop() {
    tid && clearTimeout(tid);
}
function update() {
    stop();
    store.dispatch("ticket/update");
    tid = setTimeout(update, 60 * 1000);
}
addEventListener("logout", stop);
initedPromise.then(update);
